// Canonical table title strings — single source of truth for SuperAdmin defaults + tableTitle props.
// Every callsite that passes tableTitle= or indexes TABLE_NAMES should use these.

export const TABLE_TITLE_DASHBOARD = 'Dashboard';
export const TABLE_TITLE_LAUNCHPAD = 'Launchpad';
export const TABLE_TITLE_NEW_LEADS = 'Newest Leads';
export const TABLE_TITLE_CONSULTATION_BOOKED = 'Consultation Booked Leads';
export const TABLE_TITLE_CONSULTATION_ATTENDED = 'Consultation Attended Leads';
export const TABLE_TITLE_TREATMENT_STARTED = 'Treatment Started Leads';
export const TABLE_TITLE_FAILED_TO_ATTEND = 'Failed to attend Leads';
export const TABLE_TITLE_COMPLETED = 'Completed Leads';
export const TABLE_TITLE_ARCHIVED = 'Archived Leads';
export const TABLE_TITLE_NO_TASK = 'No Task Assigned';
export const TABLE_TITLE_ALIGNER = 'Aligner Approve Leads';
export const TABLE_TITLE_ATTENDED_CHECKLISTS = 'Attended Checklists';
export const TABLE_TITLE_CONSULTATION_CLINCHECK = 'Consultation ClinCheck Leads';
